import { render, staticRenderFns } from "./Cover.vue?vue&type=template&id=529b415b&scoped=true&"
import script from "./Cover.vue?vue&type=script&lang=js&"
export * from "./Cover.vue?vue&type=script&lang=js&"
import style0 from "./Cover.vue?vue&type=style&index=0&id=529b415b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529b415b",
  null
  
)

export default component.exports